
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";

interface FilmTabButtonsProps {
  activeTab: 'unexposed' | 'exposed'; 
  onTabChange: (tab: 'unexposed' | 'exposed') => void;
}

export function FilmTabButtons({ activeTab, onTabChange }: FilmTabButtonsProps) {
  const { t } = useTranslation();
  
  return (
    <div className="flex space-x-3 border-b pb-3 mb-4">
      <Button 
        variant={activeTab === 'unexposed' ? "default" : "ghost"} 
        className="rounded-full"
        onClick={() => onTabChange('unexposed')}
      >
        {t('unexposed')}
      </Button>
      <Button 
        variant={activeTab === 'exposed' ? "default" : "ghost"} 
        className="rounded-full"
        onClick={() => onTabChange('exposed')}
      >
        {t('exposed')}
      </Button>
    </div>
  );
}
